// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-TermsLink__wrapper","inline":"c-TermsLink__inline","block":"c-TermsLink__block","link":"c-TermsLink__link"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/TermsLink/TermsLink.scss
// module id = 507
// module chunks = 0